import { ID } from './common';
import { Cliente } from './cliente';

export const InmuebleEstado = {
  LIBRE: 'LIBRE',
  ALQUILADO: 'ALQUILADO',
} as const;
export type InmuebleEstado = typeof InmuebleEstado[keyof typeof InmuebleEstado];

export const DestinoInmueble = {
  COMERCIAL: 'COMERCIAL',
  PARTICULAR: 'PARTICULAR',
  // PISO: 'PISO', // Deprecated
  // HABITACION: 'HABITACION', // Deprecated
} as const;
export type DestinoInmueble = typeof DestinoInmueble[keyof typeof DestinoInmueble];

export interface PropietarioInmueble extends Cliente {
  porcentaje_propiedad?: number;
  no_comision?: boolean;
  no_irpf?: boolean;
}

export interface ContratoActivo {
  id: ID;
  numero_contrato: string;
  fecha_inicio: string;
  fecha_fin: string;
  inquilino_id: ID;
  inquilino_nombre: string;
  inquilino_tipo_documento?: string;
  inquilino_documento?: string;
  inquilino_email?: string;
  inquilino_telefono?: string;
  monto_alquiler_propietario?: number;
  moneda_propietario?: string;
}

export interface ContratoHistorico {
  id: ID;
  numero_contrato: string;
  fecha_inicio: string;
  fecha_fin: string;
  estado: string;
  monto_alquiler_inquilino: number;
  moneda_inquilino: string;
  monto_alquiler_propietario?: number;
  moneda_propietario?: string;
  tipo_contrato: string;
  inquilino_nombre: string;
  inquilino_id: ID;
  inquilino_tipo_documento?: string;
  inquilino_documento?: string;
}

export interface Inmueble {
  id: ID;
  direccion: string;
  padron?: string;
  ciudad: string;
  descripcion?: string;
  destino_inmueble?: DestinoInmueble;
  estado: InmuebleEstado;
  creado_por?: ID;
  created_at?: string;
  updated_at?: string;
  full_address?: string;
  propietarios?: PropietarioInmueble[];
  contrato_activo?: ContratoActivo;
  contratos?: ContratoHistorico[];
}

